import React, { Fragment } from "react";
import PropTypes from "prop-types";
import StofComponent from "../shared/StofComponent";
import Fieldset from "../common/Fieldset";

const VerbodenStofDetailForm = (props) => {
    const {
        model
    } = props;

    return <Fragment>
        <Fieldset>
            <StofComponent model={model} />
        </Fieldset>
    </Fragment>;
};

VerbodenStofDetailForm.propTypes = {
    model: PropTypes.object
};

export default VerbodenStofDetailForm;